import styled from 'styled-components';

export const PadlockStatusContainer = styled.div`
  display: inline-flex;
  align-items: center;

  .padlock-status-tag {
    margin: 0;
  }

  .padlock-status-divider {
    margin: 0 12px;
  }

  .padlock-status-button {
    display: grid;
    place-items: center;
  }
`;
